// Single coherent illustrative scenario shared across Hero + Product section.
// FICTIONAL SAMPLE DATA — not live, not validated.
export const SCENARIO = {
  event:
    "Regional route disruption affecting two chartered vessels and three active contracts.",
  eventShort: "Regional Route Disruption",
  situation:
    "Route disruption affecting two vessels and three contracts.",
  affected: { vessels: 2, contracts: 3 },
  exposure: "USD 1.8M–2.4M",
  action: "Renegotiate Affected Charter Terms",
  window: "72 hours",
  confidence: "Moderate–High",
  scenariosEvaluated: 4,
  drivers: [
    "Charter-party provisions",
    "Route disruption",
    "Bunker-cost movement",
    "Counterparty history",
  ],
  options: [
    "Continue Current Terms",
    "Renegotiate Affected Charter Terms",
    "Redirect or Reallocate Capacity",
    "Delay or Restructure Commitments",
  ],
  sourceCategories: [
    "Charter-party provisions",
    "Operational data",
    "Route-disruption information",
    "Market and bunker-cost data",
    "Counterparty history",
    "Internal commercial context",
  ],
};

export const HERO_DISCLAIMER =
  "Illustrative prototype using fictional sample data. Capabilities shown represent the planned platform and pilot direction.";

export const PRODUCT_DISCLAIMER =
  "Illustrative prototype interface using fictional sample data. Capabilities shown represent the planned platform and pilot direction.";
